/**
 * Sprint-003 A5 — shown when a queued/live mutation 401'd (the session
 * needs a fresh sign-in). Distinct from `OfflineBanner`: this is a
 * reachable server actively rejecting a stale session, not a connectivity
 * problem — different color/copy so the two are never confused, per
 * design-spec-today-card.md §1's "color is never the only cue, but is
 * never wrong either" principle.
 *
 * Sprint-007 D6 — copy fixed (flagged stale in the sprint-007 D3/PR #3
 * review): the old "open it again" line was written for the pre-auth-v2
 * world where a magic link was the ONLY way back in. Under ADR-002
 * Amendment 4 a session now goes stale mid-use exactly like any other app
 * (`LoginView`, not a link, is the way back in) — the copy now says
 * "sign in again," matching the new login flow's voice rather than the
 * retired link-only model.
 */
export function ReauthBanner({ visible }: { visible: boolean }) {
  if (!visible) return null;
  return (
    <div class="reauth-banner" role="status" aria-live="polite">
      <span class="offline-icon" aria-hidden="true">
        ⟳
      </span>
      <span>Time to sign in again — your taps are saved.</span>
    </div>
  );
}
